export default function getTranslation (key: string) {
    //@ts-ignore
    if (!window.translations || !Object.keys(window.translations).length || !window.translations[key] ) {
        return key;
    }

    //@ts-ignore
    return window.translations[key];
}